module.exports = __webpack_public_path__ + "img/lt_register.1689743d.png";